/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function TemplatesSearchViewController(
    this: JS5Object,
    $location: JS5Object,
    $q: JS5Object,
    loginService: JS5Object,
    uiGridConstants: JS5Object,
    ConditionalTemplatesService: JS5Object,
    DeliveryTemplatesService: JS5Object,
    EmailTemplatesService: JS5Object,
    FfmpegTemplatesService: JS5Object,
    ImageTemplatesService: JS5Object,
    IntermediateTemplatesService: JS5Object,
    MacCaptionTemplatesService: JS5Object,
    MediaAcceptProfileService: JS5Object,
    MediaConversionTemplateService: JS5Object,
    ModalService: JS5Object,
    NavbarUtilService: JS5Object,
    NotificationService: JS5Object,
    PackageAcceptTemplatesService: JS5Object,
    PackageCreationTemplatesService: JS5Object,
    PaginationService: JS5Object,
    PermissionsService: JS5Object,
    SearchFilterService: JS5Object,
    TransformTemplatesService: JS5Object,
    UtilsService: JS5Object,
) {
    this.showHidden = false;
    this.toolbarCheckboxDefs = [];
    this.toolbarButtonDefs = [];
    const getData = () => {
        getGridConfig();

        let promises = [];
        let systemOpsPromise = PermissionsService.isSystemOperator().then((isSystemOps: boolean) => {
            this.canReadPackageTemplates = isSystemOps;
        });
        promises.push(systemOpsPromise);

        let offset = this.pagingOptions.pageSize * (this.pagingOptions.currentPage - 1);
        let queryOptions = {
            fetchOffset: this.enablePagination ? offset : 0,
            fetchLimit: this.enablePagination ? this.pagingOptions.pageSize : 0,
            searchString: $location.search().searchText,
            keywords: $location.search().searchText,
            includeHidden: this.showHidden
        };

        if (this.serviceGetAllFunction && this.gridOptions.columnDefs) {
            this.loadingIndicator.show = true;
            let serviceGetAllFunctionPromise: any = _.invoke(this, 'serviceGetAllFunction', queryOptions)
                .then((data: JS5Object) => {
                    this.gridOptions.data = data;
                });
            promises.push(serviceGetAllFunctionPromise);
        }
        $q.all(promises).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const getGridConfig = () => {
        this.currentTab = _.get(this.tabs, $location.search().tab, this.tabs.DeliveryTemplates);
        this.currentSubTab = _.get(this.currentTab, `subTabs.${$location.search().subTab}`);

        this.enablePagination = _.get(this, 'currentSubTab.enablePagination') ?
            _.get(this, 'currentSubTab.enablePagination') :
            _.get(this, 'currentTab.enablePagination');

        this.gridOptions.columnDefs = _.get(this, 'currentSubTab.columnDefinitions') ?
            _.get(this, 'currentSubTab.columnDefinitions') :
            _.get(this, 'currentTab.columnDefinitions');

        this.serviceGetAllFunction = _.get(this, 'currentSubTab.serviceGetAllDataFunction') ?
            _.get(this, 'currentSubTab.serviceGetAllDataFunction') :
            _.get(this, 'currentTab.serviceGetAllDataFunction');

        this.toolbarButtonDefs = _.get(this, 'currentSubTab.toolbarButtonDefs') ?
            _.get(this, 'currentSubTab.toolbarButtonDefs') :
            _.get(this, 'currentTab.toolbarButtonDefs');

        this.toolbarCheckboxDefs = _.get(this, 'currentSubTab.toolbarCheckboxDefs') ?
            _.get(this, 'currentSubTab.toolbarCheckboxDefs') :
            _.get(this, 'currentTab.toolbarCheckboxDefs');

        if (this.toolbarCheckboxDefs) {
            _.set(this, 'toolbarCheckboxDefs[0].isChecked', this.showHidden);
        }
    };

    const navigateToEditViewFromDoubleClick = (entity: JS5Object) => {
        if (this.currentSubTab === this.tabs.Media.subTabs.MediaAcceptProfiles) {
            $location.url(`/system/templates/${this.currentSubTab.editRoute}/edit/${_.get(entity, 'id')}?editView=properties`);
        } else if (!!this.currentSubTab) {
            $location.url(`/system/templates/${this.currentSubTab.editRoute}/edit/${_.get(entity, 'id')}`);
        } else {
            $location.url(`/system/templates/${this.currentTab.editRoute}/edit/${_.get(entity, 'id')}`);
        }
    };

    const navigateToEditViewFromEditButton = () => {
        if (this.currentSubTab === this.tabs.Media.subTabs.MediaAcceptProfiles) {
            $location.url(`/system/templates/${this.currentSubTab.editRoute}/edit/${_.get(_.first(this.gridApi.selection.getSelectedRows()), 'id')}?editView=properties`);
        } else if (!!this.currentSubTab) {
            $location.url(`/system/templates/${this.currentSubTab.editRoute}/edit/${_.get(_.first(this.gridApi.selection.getSelectedRows()), 'id')}`);
        } else {
            $location.url(`/system/templates/${this.currentTab.editRoute}/edit/${_.get(_.first(this.gridApi.selection.getSelectedRows()), 'id')}`);
        }
    };

    const navigateToCreateView = () => {
        if (!!this.currentSubTab) {
            $location.url(`/system/templates/${this.currentSubTab.editRoute}/edit/-1`);
        } else {
            $location.url(`/system/templates/${this.currentTab.editRoute}/edit/-1`);
        }
    };
    const deleteItem = () => {
        let entityToDelete = _.first(this.gridApi.selection.getSelectedRows());
        const typeOfEntityToDelete = _.get(this, 'currentSubTab.displayName') ? this.currentSubTab.displayName : this.currentTab.displayName;
        this.serviceDeleteFunction = _.get(this, 'currentSubTab.serviceDeleteFunction') ? this.currentSubTab.serviceDeleteFunction : this.currentTab.serviceDeleteFunction;

        ModalService.showMessageModal({
            messageText: `Are you sure you want to delete the selected ${typeOfEntityToDelete}?`,
            pullCancelLeft: true,
            title: `Delete ${typeOfEntityToDelete}`,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            if (this.serviceDeleteFunction) {
                this.loadingIndicator.show = true;
                let serviceDeleteFunctionPromise: any = _.invoke(this, 'serviceDeleteFunction', _.get(entityToDelete, 'id'));
                serviceDeleteFunctionPromise.then(() => {
                    NotificationService.createSuccessNotification(`${typeOfEntityToDelete} deleted successfully!`);
                    getData();
                }).catch(() => {
                    NotificationService.createFailureNotification(`Could not delete the selected ${typeOfEntityToDelete}`);
                }).finally(() => {
                    this.loadingIndicator.show = false;
                });
            }
        });
    };

    const cloneItem = () => {
        let entityToClone = _.first(this.gridApi.selection.getSelectedRows());
        const typeOfEntityToClone = _.get(this, 'currentSubTab.displayName') ? this.currentSubTab.displayName : this.currentTab.displayName;
        this.serviceCloneFunction = _.get(this, 'currentSubTab.serviceCloneFunction') ? this.currentSubTab.serviceCloneFunction : this.currentTab.serviceCloneFunction;

        ModalService.showMessageModal({
            messageText: `Are you sure you want to clone the selected ${typeOfEntityToClone}?`,
            pullCancelLeft: true,
            title: `Clone ${typeOfEntityToClone}`,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            if (this.serviceCloneFunction) {
                this.loadingIndicator.show = true;
                let serviceCloneFunctionPromise: any = _.invoke(this, 'serviceCloneFunction', entityToClone);
                serviceCloneFunctionPromise.then(() => {
                    NotificationService.createSuccessNotification(`${typeOfEntityToClone} cloned successfully!`);
                    getData();
                }).catch(() => {
                    NotificationService.createFailureNotification(`Could not clone the selected ${typeOfEntityToClone}`);
                }).finally(() => {
                    this.loadingIndicator.show = false;
                });
            }
        });
    };

    const toggleItemHidden = () => {
        let entityToHide = _.first(this.gridApi.selection.getSelectedRows());
        let isHidden = _.get(entityToHide, 'hidden');
        const actionType = isHidden ? 'Unhide' : 'Hide';
        const typeOfEntityToHide = _.get(this, 'currentSubTab.displayName') ? this.currentSubTab.displayName : this.currentTab.displayName;
        this.serviceToggleHiddenFunction = _.get(this, 'currentSubTab.serviceToggleHiddenFunction') ? this.currentSubTab.serviceToggleHiddenFunction : this.currentTab.serviceToggleHiddenFunction;

        ModalService.showMessageModal({
            messageText: `Are you sure you want to ${_.lowerCase(actionType)} the selected ${typeOfEntityToHide}?`,
            pullCancelLeft: true,
            title: `${actionType} ${typeOfEntityToHide}`,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            if (this.serviceToggleHiddenFunction) {
                this.loadingIndicator.show = true;
                let serviceToggleHiddenFunctionPromise: any = _.invoke(this, 'serviceToggleHiddenFunction', _.get(entityToHide, 'id'));
                serviceToggleHiddenFunctionPromise.then(() => {
                    NotificationService.createSuccessNotification(`${_.lowerCase(typeOfEntityToHide)} ${actionType}n successfully!`);
                    getData();
                }).catch(() => {
                    NotificationService.createFailureNotification(`Could not ${_.lowerCase(actionType)} the selected ${typeOfEntityToHide}`);
                }).finally(() => {
                    this.loadingIndicator.show = false;
                });
            }
        });
    };

    this.changeTab = (tab: JS5Object) => {
        initPaging();
        this.currentTab = tab;
        this.showHidden = false;
        $location.search('showHidden', null);
        if (_.has(tab, 'subTabs')) {
            $location.search('tab', tab.type);
        } else {
            $location.search('tab', tab.type);
            $location.search('subTab', null);
            getData();
        }
    };

    this.changeSubTab = (subTab: JS5Object) => {
        initPaging();
        this.currentSubTab = subTab;
        this.showHidden = false;
        $location.search('showHidden', null);
        $location.search('subTab', subTab.type);
        getData();
    };

    this.processGridFilter = (rows: JS5Object) => {
        const searchText = $location.search().searchText;
        if (_.get(this, 'currentTab.useFrontEndSearch')) {
            if (_.size(searchText)) {
                rows.forEach((row: JS5Object) => {
                    _.set(row, 'visible', _.includes(_.toLower(row.entity.name), _.toLower(searchText)));
                });
            }
        }
        if (_.get(this, 'currentSubTab.useFrontEndSearch')) {
            if (_.size(searchText)) {
                rows.forEach((row: JS5Object) => {
                    _.set(row, 'visible', _.includes(_.toLower(row.entity.name), _.toLower(searchText)));
                });
            }
        }
        return rows;
    };

    this.tabs = {
        DeliveryTemplates: {
            type: 'DeliveryTemplates',
            tabName: 'Delivery',
            displayName: 'Delivery Template',
            editRoute: 'deliveryTemplates',
            useFrontEndSearch: true,
            serviceGetAllDataFunction: DeliveryTemplatesService.getAllDeliveryTemplates,
            serviceCloneFunction: DeliveryTemplatesService.cloneDeliveryTemplate,
            serviceDeleteFunction: DeliveryTemplatesService.deleteDeliveryTemplate,
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    minWidth: 250,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'artwork',
                    displayName: 'Artwork',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'audio',
                    displayName: 'Audio',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'closedCaption',
                    displayName: 'CC',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'image',
                    displayName: 'Image',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'metadata',
                    displayName: 'Metadata',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'subtitle',
                    displayName: 'Subtitle',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                },
                {
                    field: 'video',
                    displayName: 'Video',
                    cellTemplate: 'components/visual/grid/radio-button-template.html'
                }
            ],
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: () => true,
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) && !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'custom'),
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) && !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'custom'),
                    onClick: cloneItem
                },
                {
                    label: 'Delete',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) && !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'custom'),
                    onClick: deleteItem
                }
            ]
        },
        EmailTemplates: {
            type: 'EmailTemplates',
            tabName: 'Email',
            displayName: 'Email Template',
            editRoute: 'emailTemplates',
            useFrontEndSearch: true,
            enablePagination: true,
            serviceGetAllDataFunction: EmailTemplatesService.getAllEmailTemplates,
            serviceCloneFunction: EmailTemplatesService.cloneEmailTemplate,
            serviceToggleHiddenFunction: EmailTemplatesService.toggleEmailTemplateHidden,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: () => true,
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Hide',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                    onClick: toggleItemHidden
                },
                {
                    label: 'Unhide',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                        _.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                    onClick: toggleItemHidden
                }
            ],
            toolbarCheckboxDefs: [
                {
                    label: 'Show Hidden',
                    onUpdate: (newState: boolean) => {
                        this.showHidden = newState;
                        $location.search('showHidden', newState);
                        getData();
                    },
                    isChecked: this.showHidden
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    minWidth: 250,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        HybrikTemplates: {
            type: 'HybrikTemplates',
            tabName: 'Hybrik',
            displayName: 'Hybrik Template',
            editRoute: 'hybrikTemplates',
            useFrontEndSearch: true,
            enablePagination: false,
            serviceGetAllDataFunction: () => MediaConversionTemplateService.getTypedMediaConversionTemplates('Hybrik'),
            serviceDeleteFunction: MediaConversionTemplateService.deleteMediaConversionTemplate,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: () => true,
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Delete',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: deleteItem
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    minWidth: 250,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        FfmpegTemplates: {
            type: 'FfmpegTemplates',
            tabName: 'FFmpeg',
            displayName: 'FFmpeg Template',
            editRoute: 'ffmpegTemplates',
            useFrontEndSearch: true,
            enablePagination: false,
            serviceGetAllDataFunction: FfmpegTemplatesService.getAllFfmpegTemplates,
            serviceCloneFunction: FfmpegTemplatesService.cloneFfmpegTemplate,
            serviceDeleteFunction: FfmpegTemplatesService.toggleFfmpegTemplateHidden,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: () => true,
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: cloneItem
                },
                {
                    label: 'Delete',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: deleteItem
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    minWidth: 250,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        IntermediateTemplates: {
            type: 'IntermediateTemplates',
            tabName: 'Intermediate',
            displayName: 'Intermediate Template',
            editRoute: 'intermediateTemplates',
            useFrontEndSearch: true,
            enablePagination: false,
            serviceGetAllDataFunction: IntermediateTemplatesService.getAllIntermediateTemplates,
            serviceCloneFunction: IntermediateTemplatesService.cloneIntermediateTemplate,
            serviceDeleteFunction: IntermediateTemplatesService.deleteIntermediateTemplate,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: () => true,
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: cloneItem
                },
                {
                    label: 'Delete',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: deleteItem
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    minWidth: 250,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'programStartOffset',
                    displayName: 'Program Start Offset',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'programEndOffset',
                    displayName: 'Program End Offset',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        PackageCreationTemplates: {
            type: 'PackageCreationTemplates',
            tabName: 'Package Creation Templates',
            displayName: 'Package Creation Templates',
            editRoute: 'packageCreationTemplates',
            useFrontEndSearch: true,
            enablePagination: false,
            serviceGetAllDataFunction: PackageCreationTemplatesService.getAllPackageCreationTemplates,
            serviceDeleteFunction: PackageCreationTemplatesService.deletePackageCreationTemplate,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: () => true,
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Delete',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: deleteItem
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    width: 350,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'template',
                    displayName: 'Template',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        ConditionalTemplates: {
            type: 'ConditionalTemplates',
            tabName: 'Conditional',
            displayName: 'Conditional Template',
            editRoute: 'conditionalTemplates',
            useFrontEndSearch: true,
            enablePagination: false,
            serviceGetAllDataFunction: ConditionalTemplatesService.getAllConditionalTemplates,
            serviceCloneFunction: ConditionalTemplatesService.cloneConditionalTemplate,
            serviceDeleteFunction: ConditionalTemplatesService.deleteConditionalTemplate,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: () => true,
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: cloneItem
                },
                {
                    label: 'Delete',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: deleteItem
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    minWidth: 250,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                },
                {
                    field: 'expression',
                    displayName: 'Expression',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        TransformTemplates: {
            type: 'TransformTemplates',
            tabName: 'Transform',
            displayName: 'Transform Template',
            editRoute: 'transformTemplates',
            useFrontEndSearch: false,
            enablePagination: true,
            serviceGetAllDataFunction: TransformTemplatesService.getAllTransformTemplates,
            serviceCloneFunction: TransformTemplatesService.cloneTransformTemplate,
            serviceToggleHiddenFunction: TransformTemplatesService.toggleTransformTemplateHidden,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: () => true,
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: cloneItem
                },
                {
                    label: 'Hide',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                    onClick: toggleItemHidden
                },
                {
                    label: 'Unhide',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                        _.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                    onClick: toggleItemHidden
                }
            ],
            toolbarCheckboxDefs: [
                {
                    label: 'Show Hidden',
                    onUpdate: (newState: boolean) => {
                        this.showHidden = newState;
                        $location.search('showHidden', newState);
                        getData();
                    },
                    isChecked: this.showHidden
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    sort: {
                        direction: 'asc',
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        ImageTemplates: {
            type: 'ImageTemplates',
            tabName: 'Image',
            displayName: 'Image Template',
            editRoute: 'imageTemplates',
            useFrontEndSearch: false,
            enablePagination: true,
            serviceGetAllDataFunction: ImageTemplatesService.getAllImageTemplates,
            serviceCloneFunction: ImageTemplatesService.cloneImageTemplate,
            serviceDeleteFunction: ImageTemplatesService.deleteImageTemplate,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: () => true,
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: cloneItem
                },
                {
                    label: 'Delete',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: deleteItem
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    sort: {
                        direction: 'asc',
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        MacCaptionTemplates: {
            type: 'MacCaptionTemplates',
            tabName: 'MacCaption',
            displayName: 'MacCaption Template',
            editRoute: 'macCaptionTemplates',
            useFrontEndSearch: false,
            enablePagination: true,
            serviceGetAllDataFunction: MacCaptionTemplatesService.getAllMacCaptionTemplates,
            serviceCloneFunction: MacCaptionTemplatesService.cloneMacCaptionTemplate,
            serviceToggleHiddenFunction: MacCaptionTemplatesService.toggleMacCaptionTemplateHidden,
            toolbarButtonDefs: [
                {
                    label: 'New',
                    enabled: () => true,
                    onClick: navigateToCreateView
                },
                {
                    label: 'Edit',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                    onClick: navigateToEditViewFromEditButton
                },
                {
                    label: 'Clone',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
                    onClick: cloneItem
                },
                {
                    label: 'Hide',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                        !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                    onClick: toggleItemHidden
                },
                {
                    label: 'Unhide',
                    enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                        _.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                    onClick: toggleItemHidden
                }
            ],
            toolbarCheckboxDefs: [
                {
                    label: 'Show Hidden',
                    onUpdate: (newState: boolean) => {
                        this.showHidden = newState;
                        $location.search('showHidden', newState);
                        getData();
                    },
                    isChecked: this.showHidden
                }
            ],
            columnDefinitions: [
                {
                    field: 'name',
                    displayName: 'Name',
                    sort: {
                        direction: 'asc',
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        },
        Media: {
            type: 'Media',
            tabName: 'Media',
            displayName: 'Media',
            subTabs: {
                MediaAcceptProfiles: {
                    type: 'MediaAcceptProfiles',
                    tabName: 'Media Accept Profile',
                    displayName: 'Media Accept Profile',
                    useFrontEndSearch: false,
                    editRoute: 'media/acceptProfiles',
                    enablePagination: true,
                    serviceGetAllDataFunction: MediaAcceptProfileService.getAcceptProfiles,
                    serviceCloneFunction: MediaAcceptProfileService.cloneAcceptProfile,
                    serviceToggleHiddenFunction: MediaAcceptProfileService.hideAcceptProfile,
                    toolbarButtonDefs: [
                        {
                            label: 'New',
                            enabled: () => true,
                            onClick: () => {
                                ModalService.showNewMediaProfileModal(MediaAcceptProfileService.createNewProfile, this.gridOptions.data);
                            }
                        },
                        {
                            label: 'Edit',
                            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                                !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                            onClick: navigateToEditViewFromEditButton
                        },
                        {
                            label: 'Clone',
                            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                                !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                            onClick: cloneItem
                        },
                        {
                            label: 'Hide',
                            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                                !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                            onClick: toggleItemHidden
                        },
                        {
                            label: 'Unhide',
                            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                                _.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                            onClick: toggleItemHidden
                        }
                    ],
                    toolbarCheckboxDefs: [
                        {
                            label: 'Show Hidden',
                            onUpdate: (newState: boolean) => {
                                this.showHidden = newState;
                                $location.search('showHidden', newState);
                                getData();
                            },
                            isChecked: this.showHidden
                        }
                    ],
                    columnDefinitions: [
                        {
                            field: 'name',
                            minWidth: 232,
                            displayName: 'Name',
                            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                        },
                        {
                            field: 'type',
                            minWidth: 232,
                            displayName: 'Type',
                            cellTemplate: 'system/templates/mediaAcceptProfiles/searchView/renderers/accept-profile-tooltip-template.html'
                        }
                    ],
                },
                PackageAcceptTemplates: {
                    type: 'PackageAcceptTemplates',
                    tabName: 'Package Accept Template',
                    displayName: 'Package Accept Template',
                    useFrontEndSearch: true,
                    editRoute: 'media/packageAcceptTemplates',
                    enablePagination: false,
                    serviceGetAllDataFunction: PackageAcceptTemplatesService.getPackageAcceptTemplates,
                    serviceToggleHiddenFunction: PackageAcceptTemplatesService.deletePackageAcceptTemplate,
                    toolbarButtonDefs: [
                        {
                            label: 'New',
                            enabled: () => true,
                            onClick: navigateToCreateView
                        },
                        {
                            label: 'Edit',
                            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                                !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                            onClick: navigateToEditViewFromEditButton
                        },
                        {
                            label: 'Hide',
                            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                                !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                            onClick: toggleItemHidden
                        },
                        {
                            label: 'Unhide',
                            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                                _.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
                            onClick: toggleItemHidden
                        }
                    ],
                    toolbarCheckboxDefs: [
                        {
                            label: 'Show Hidden',
                            onUpdate: (newState: boolean) => {
                                this.showHidden = newState;
                                $location.search('showHidden', newState);
                                getData();
                            },
                            isChecked: this.showHidden
                        }
                    ],
                    columnDefinitions: [
                        {
                            field: 'name',
                            displayName: 'Name',
                            sort: {
                                direction: uiGridConstants.ASC,
                                priority: 0
                            },
                            cellTemplate: 'system/templates/mediaAcceptProfiles/searchView/renderers/accept-profile-tooltip-template.html'
                        }
                    ],
                }
            }
        }
    };


    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        columnDefs: [],
        data: [],
        multiSelect: false,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            this.gridApi.grid.registerRowsProcessor(this.processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };

    this.onRowDblClick = (row: JS5Object) => {
        let shouldNavigate = true;
        if (this.currentTab === this.tabs.DeliveryTemplates && row.entity.custom) {
            shouldNavigate = false;
        }

        if (shouldNavigate) {
            navigateToEditViewFromDoubleClick(row.entity);
        }
    };

    this.onPaginationChanged = () => {
        getData();
    };
    this.paginationJumpToPageHandler = () => {
        this.onPaginationChanged();
    };

    this.paginationPageSizeChanged = () => {
        this.pagingOptions.currentPage = 1;
        this.onPaginationChanged();
    };

    this.paginationPrevPageHandler = () => {
        --this.pagingOptions.currentPage;
        this.onPaginationChanged();
    };

    this.paginationNextPageHandler = () => {
        ++this.pagingOptions.currentPage;
        this.onPaginationChanged();
    };


    const initPaging = () => {
        this.pagingOptions = PaginationService;
        this.pagingOptions.currentPage = 1;
        this.pagingOptions.pageSize = UtilsService.constants.DEFAULT_FETCH_LIMIT;

        this.paginationDefs = {
            paginationPrevPageHandler: this.paginationPrevPageHandler,
            paginationNextPageHandler: this.paginationNextPageHandler,
            paginationPageSizeChanged: this.paginationPageSizeChanged,
            paginationJumpToPageHandler: this.paginationJumpToPageHandler,
            pagingOptions: PaginationService,
        };
    };

    this.$onInit = () => {
        $location.search('editView', null);
        initPaging();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        NavbarUtilService.viewSearchFunction = getData;
        SearchFilterService.populateCriteriaFromLocationSearch();
        getData();
    };
}

angular.module('prism-ui.templates').component('templatesSearchView', {
    templateUrl: 'system/templates/searchView/templates-search-view-template.html',
    controller: TemplatesSearchViewController
});
